import {post} from '../../common/utils/FetchUtils';

export async function createPlayer({
  email,
  wantsNewslettersEmails,
  language,
  firstName,
  lastName,
  dateOfBirth,
  gender,
  displayName,
}) {
  return post('/api/players', {
    email,
    wantsNewslettersEmails,
    language,
    firstName,
    lastName,
    dateOfBirth: dateOfBirth.toISOString(),
    gender,
    displayName,
  });
}
